const DB_NAME = "DeliveryTrackerPhotos";
const DB_STORE = "photos_v1";

export function openIdb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = (ev) => {
      const db = ev.target.result;
      if (!db.objectStoreNames.contains(DB_STORE)) {
        db.createObjectStore(DB_STORE);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function idbPut(key, blob) {
  const db = await openIdb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(DB_STORE, "readwrite");
    const store = tx.objectStore(DB_STORE);
    const rq = store.put(blob, key);
    rq.onsuccess = () => {
      tx.oncomplete = () => {
        db.close();
        resolve(true);
      };
    };
    rq.onerror = () => {
      db.close();
      reject(rq.error);
    };
  });
}

export async function idbDelete(key) {
  const db = await openIdb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(DB_STORE, "readwrite");
    const store = tx.objectStore(DB_STORE);
    const rq = store.delete(key);
    rq.onsuccess = () => {
      tx.oncomplete = () => {
        db.close();
        resolve(true);
      };
    };
    rq.onerror = () => {
      db.close();
      reject(rq.error);
    };
  });
}
